module.exports = __webpack_public_path__ + "img/0Q3A4053_L_Black_MockedUp.e5f3d264.jpg";